import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "../../../api";
import toastMessages from "../../helpers/toastMessage";
import { useOktaAuth } from "@okta/okta-react";
import { AxiosError } from "axios";

function useGenerateLabel(
  selectedRowIds: any[],
  setLabelPopup: (value: boolean) => void,
  setSubmitting: (value: boolean) => void
) {
  const authState = useOktaAuth()?.authState;
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["generateLabel"],
    mutationFn: (values: any) => {
      const { firstName, lastName, stateValue, ...restValues } = values;
      const personName = `${firstName} ${lastName}`;
      const state = !!stateValue ? stateValue : restValues?.state;
      setSubmitting(true);
      return axiosInstance.post(
        "v1/fedex/generate-label",
        {
          ...restValues,
          personName,
          state,
          orderIds: selectedRowIds?.map((e: any) => e?.id),
        },
        {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        }
      );
    },
    onSuccess: (response: any) => {
      toastMessages.success("Label generated!");
      if (response?.data?.labelUrl) {
        window.open(response?.data?.labelUrl, "_blank");
      }
      setLabelPopup(false);
      setSubmitting(false);

      queryClient.invalidateQueries({ queryKey: ["testOrdersList"] });
    },
    onError: (error: AxiosError<any, any>) => {
      const errorCode = error?.response?.data?.errors?.[0]?.code;
      let errorMsg =
        error?.response?.data?.errors?.[0]?.message ?? error.message;

      if (errorCode === "COUNTRY.POSTALCODEORZIP.INVALID") {
        errorMsg = "Please enter valid zip code";
      }

      toastMessages.error(errorMsg);
      setSubmitting(false);
    },
  });
}

export default useGenerateLabel;
